import {
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
    navigateToTravelQuote,
    navigateToSelectPlan,
    navigateToConfirmDetails,
    navigateToTravelerDetails,
    navigateToPayment,
} from '../../../actions/travelKe/routing';
import { getActivePageIndex } from '../../../selectors/travelKe/routing';
import { PAGE_INDICES } from '../../../actions/travelKe/types';
import { apiTransitionPayloadCollection } from '../../../actions/travelKe/payloadCollection';

export const routingRules = (store, next, action) => {
    if (action.type !== NAVIGATE_NEXT && action.type !== NAVIGATE_PREVIOUS) return next(action);
    const result = next(action);
    const state = store.getState();
    const activePageIndex = getActivePageIndex(state);
    if (action.type === NAVIGATE_NEXT) {
        onNavigateNext(store, state, activePageIndex);
        return result;
    }
    onNavigatePrevious(store, state, activePageIndex);
    return result;
};

const onNavigateNext = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.QOUTE:
            store.dispatch(navigateToSelectPlan());
            break;
        case PAGE_INDICES.SELECT_PLAN:
            store.dispatch(navigateToConfirmDetails());
            break;
        case PAGE_INDICES.CONFIRM_DETAILS:
            store.dispatch(navigateToTravelerDetails());
            break;
        case PAGE_INDICES.TRAVELER_DETAILS:
            store.dispatch(navigateToPayment());
            break;
        default:
            store.dispatch(navigateToTravelQuote());
            break;
    }
};

const onNavigatePrevious = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.PAYMENT:
            store.dispatch(apiTransitionPayloadCollection.initial());
            store.dispatch(navigateToTravelerDetails());
            break;
        case PAGE_INDICES.TRAVELER_DETAILS:
            store.dispatch(navigateToConfirmDetails());
            break;
        case PAGE_INDICES.CONFIRM_DETAILS:
            store.dispatch(navigateToSelectPlan());
            break;
        case PAGE_INDICES.SELECT_PLAN:
            store.dispatch(navigateToTravelQuote());
            break;
        default:
            store.dispatch(navigateToTravelQuote());
            break;
    }
};
